import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Label, Button } from 'semantic-ui-react';
import Message from '../common/Message';
import LoginButton from '../common/LoginButton';
import GuestUserLoginToast from '../common/GuestUserLoginAlert';
import SubscribeModal from '../common/subscribe_modal/subscribe_modal';
import { handleSeeAllWithSubscription } from '../../common/subscriptionHelper';

const INITIAL_VISIBLE = 5;

class PeopleTabView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleCount: INITIAL_VISIBLE,
            loading: false,
            showLoginAlert: false,
            showSubscribeModal: false,
        };
    }

    getInitials = (userName) => {
        const fullName = userName.split(' ');
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
        return initials.toUpperCase();
    }

    showLoginModalnew = (flag) => {
        this.props.ShowLogin(flag);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.companyId !== this.props.companyId) {
            this.setState({ visibleCount: INITIAL_VISIBLE });
        }
    }

    handleMoreClick = () => {
        const { auth, employees } = this.props;
        const totalCount = employees?.Items?.length || 0;

        handleSeeAllWithSubscription({
            auth,
            onShowLogin: () => this.setState({ showLoginAlert: true }),
            onShowSubscribeModal: () => this.setState({ showSubscribeModal: true }),
            onSubscribed: () => {
                this.setState({ loading: true });
                setTimeout(() => {
                    this.setState({
                        visibleCount: totalCount,
                        loading: false,
                    });
                }, 1000);
            },
        });
    }

    render() {
        const { employees, auth } = this.props;
        const { visibleCount, loading, showLoginAlert, showSubscribeModal } = this.state;
        const employeeItems = employees?.Items || [];
        const displayedEmployees = employeeItems.slice(0, visibleCount);
        const hasMore = employeeItems.length > visibleCount;

        return (
            <React.Fragment>
                <div className="py-2 px-0 border-1-radius background-white">
                    <div className="companypeople-list">
                        {displayedEmployees.map(employee => (
                            <div className="item px-2" key={employee.key}>
                                <div className="companypeople-left">
                                    <div className="images">
                                        {employee.image
                                            ? <img alt={employee.image} className="ui avatar image" src={employee.image} />
                                            : <Label circular color="grey">{this.getInitials(employee.user_name)}</Label>
                                        }
                                    </div>
                                    <Link to={`/networkFeed/user/${employee.user_id}`}>
                                        <div className="content">
                                            <h4>{employee.user_name}</h4>
                                            <p>{employee.designation}</p>
                                        </div>
                                    </Link>
                                </div>
                                <div className="right floated content">
                                    <Message auth={auth} userId={employee.user_id} userName={employee.user_name} showLoginModalnew={this.showLoginModalnew} />
                                </div>
                            </div>
                        ))}
                    </div>
                    {hasMore && (
                        <div className="text-center px-2 pb-2">
                            {auth
                                ? <Button className="color-light-blue w-100 text-center mt-2 cursor-pointer load_more" onClick={this.handleMoreClick} loading={loading}>See All</Button>
                                : <LoginButton />
                            }
                        </div>
                    )}
                </div>
                <GuestUserLoginToast {...this.props} show={showLoginAlert} setStateLoginClose={() => this.setState({ showLoginAlert: false })} />
                <SubscribeModal open={showSubscribeModal} onClose={() => this.setState({ showSubscribeModal: false })} />
            </React.Fragment>
        );
    }
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(PeopleTabView);
